import RecordBase from './../tools/RecordBase';

class Email extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'emails';
    this.title = 'Email';
    this.state.columns = [
        {
          field: 'Config',
          headerName: 'Email',
          width: 250,
        },
      ];
  }

}

export default Email;
